import React, { useEffect, useState, useRef } from "react";
import "../../Styles/Product_details/Product_details-final.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import {
  faArrowPointer,
  faArrowRight,
  faCartPlus,
  faLocation,
  faStar,
  faAward,
  faRightLeft,
  faBriefcase,
  faTruck,
  faWarning,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faStarHalfStroke } from "@fortawesome/free-solid-svg-icons";
import ProductDetails from "../../Pages/ProductDetails.jsx";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import SimilarProducts from "../Card_Crousel_div/Similar_Product.jsx";
import { useNavigate } from "react-router-dom";
import Navbar from "../Core/Navbar.jsx";
import Footer from "../Core/Footer.jsx";
import api from "../../api.js";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ScrollToTopButton from "../ScrollToTopButton.jsx";
import StarRating from "../StarRating.jsx";
import { showToast } from "../PopupMessage.jsx";
import FullscreenSpinner from "../FullscreenSpinner.jsx";
import "../../Styles/Home.css";
import { toast } from "react-toastify";

const items = ["Free Delivery", "Selling out fast", "So many sold recently"];

const Storage = ["180Gb", "256GB", "512GB", "1TB"];
const verson = [
  "International Version",
  "Middle East Version",
  "Physical Dual Sim Version",
  "USA Version",
];
const model = ["iPhone16 Pro Max", "iPhone 16"];

function SafeComponent({ html }) {
  const cleanHTML = DOMPurify.sanitize(html);

  return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
}

// import starEmpty from "./star-empty.png"
// import starFull from "./star-full.png"

function ProductDetailsFinal() {
  const navigate = useNavigate();
  const [productData, setProductData] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [attributeDetail, setAttributeDetail] = useState([]);
  const [attribute, setAttribute] = useState();
  const [version, setVersion] = useState([]);
  const [selectedversion, setSelectedversion] = useState(null);
  const [active, setActive] = React.useState("div1");
  const [color, setColor] = React.useState([]);
  const accessToken = localStorage.getItem("accessToken");
  const [clicked, setClicked] = useState(false);
  const [slug, setSlug] = useState("");
  const [productRatings, setProductRatings] = useState(0);
  const [productReviews, setProductReviews] = useState([]);
  const [productStock, setProductStock] = useState({});
  const [review, setReview] = useState();
  const [network, setNetwork] = useState(true);
  const [starValue, setStarValue] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [reviewOn, setReviewOn] = useState(false);
  const [productId, setProductId] = useState(0);
  const [reviewSubmit, setReviewSubmit] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    infinite: true,
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };

  let { product_url } = useParams();
  console.log("producturl", product_url);

  useEffect(() => {
    // if (selectedColor !== null) {
    //   changeProduct();
    // }
    // if (selectedAttribute !== null) {
    //   changeProduct();
    // }
    if (
      selectedColor !== null ||
      selectedAttribute !== null ||
      selectedversion !== null
    ) {
      changeProduct();
    }
  }, [selectedColor, selectedAttribute, selectedversion]);

  const changeProduct = async () => {
    console.log("selectedColor", selectedColor);
    console.log("selectedAttribute", selectedAttribute);
    console.log("selectedversion", selectedversion);

    const color = selectedColor ?? "";
    const attr = selectedAttribute ?? "";
    const version = selectedversion ?? "";

    try {
      setNetwork(true);
      const response = await api.get(
        `user_api/product/get-product-details?product_url=${product_url}&access_token=${JSON.parse(
          accessToken
        )}&color=${color}&attr=${attr}&version_id=${version}`
      );

      if (response.data.status === "success") {
        console.log("after updating response data: ", response.data);
        // setProductData([...response.data.image]);
        setNetwork(false);
        setProductData(response.data.image);
        console.log("productData: ", response.data.image);
        setProductDetails(response.data.product_details);
        console.log("product Stock :  ", response.data.product_stock);
        setProductStock(response.data.product_stock);
        setColor(response.data.colors);
        setAttribute(response.data.attribute.attr_name);
        setAttributeDetail(response.data.attribute.attr_details);
        setClicked(response.data.add_to_cart);
        setSlug(response.data.product_details[0].category_slug);
        setVersion(response.data.version);
        setProductRatings(response.data.averageRating);
        setProductReviews(response.data.rate);
        setReview(response.data.total_review);
        // ProductDetailLists();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    ProductDetailLists();
  }, []);

  const ProductDetailLists = async () => {
    try {
      const response = await api.get(
        `user_api/product/get-product-details?product_url=${product_url}&access_token=${JSON.parse(
          accessToken
        )}`
      );
      console.log("product details :", response.data);
      if (response.data.status === "success") {
        console.log("............................", response.data);
        setProductData(response.data.image);
        setProductDetails(response.data.product_details);
        setProductStock(response.data.product_stock);
        setColor(response.data.colors);
        setAttribute(response.data.attribute.attr_name);
        setAttributeDetail(response.data.attribute.attr_details);
        setClicked(response.data.add_to_cart);
        setSlug(response.data.product_details[0].category_slug);
        setVersion(response.data.version);
        setProductRatings(response.data.averageRating);
        setProductReviews(response.data.rate);
        setReview(response.data.total_review);
        setProductId(response.data.product_details[0].id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(accessToken);

  const handleAddToCart = async () => {
    console.log("uyghtgh", clicked);

    if (!accessToken) {
      navigate("/login");
      return;
    }

    if (!selectedAttribute) {
      alert("Please select an attribute.");
      return;
    }

    if (!selectedColor) {
      alert("Please select a color.");
      return;
    }
    if (version.length !== 0) {
      if (selectedversion === null) {
        alert("please select a version.");
        return;
      }
    }

    try {
      if (!clicked) {
        navigate("/cart");
      } else {
        const response = await api.post(`/user_api/cart/add-to-cart`, {
          access_token: JSON.parse(accessToken),
          product_url: product_url,
          qty: 1,
          attribute: selectedAttribute,
          color: selectedColor,
          version_id: selectedversion,
        });
        console.log("jyghjgjgjh", response.data);
        if (response.data.status === "success") {
          ProductDetailLists();
          showToast("Product added to cart successfully!", "success");
        } else {
          console.log("something fisshy");
          showToast("Something went wrong, please try again.", "error");
        }
      }
    } catch (error) {
      console.log("Error adding cart:", error);
      alert("server main problem hai");
    }
  };

  const handleBuyNow = async () => {
    if (!accessToken) {
      navigate("/login");
      return;
    }

    if (!selectedAttribute) {
      alert("Please select an attribute.");
      return;
    }

    if (!selectedColor) {
      alert("Please select a color.");
      return;
    }
    if (version.length !== 0) {
      if (selectedversion === null) {
        alert("please select a version.");
        return;
      }
    }

    try {
      const response = await api.post(`/user_api/cart/add-to-cart`, {
        access_token: JSON.parse(accessToken),
        product_url: product_url,
        qty: 1,
        attribute: selectedAttribute,
        color: selectedColor,
        version_id: selectedversion,
      });

      if (response.data.status === "success") {
        ProductDetailLists();
        showToast("Product added to cart successfully!", "success");
        navigate("/checkout");
      } else {
        showToast("Something went wrong, please try again.", "error");
      }
    } catch (error) {
      console.log("Error adding cart:", error);
      alert("server main problem hai");
    }
  };
  const targetRef = useRef(null);

  const handleReviewRatings = () => {
    targetRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const HandleRateProduct = async () => {
    if (!accessToken) {
      navigate("/login");
      return;
    }
    if (starValue === 0 || reviewText === "") {
      showToast("Enter rating and review");
      return;
    }
    setReviewSubmit(true);

    try {
      const response = await api.post(`/user_api/product/post-reviews`, {
        access_token: JSON.parse(accessToken),
        product_id: productId,
        rating: starValue,
        description: reviewText,
      });

      console.log(response.data);
      if (response.data.status === "success") {
        showToast("Review Added", "success");
        setReviewSubmit(false);
        ProductDetailLists();
      } else {
        showToast(response.data.message, "error");
      }

      console.log("rated", productId);
      console.log("ratings:-", starValue, reviewText);
    } catch (error) {
      //showToast("Failed to Add Review", "fail");
      console.log(error);
    } finally {
      setStarValue(0);
      setReviewText("");
      setReviewOn(false);
      setReviewSubmit(false);
    }
  };
  useEffect(() => {
    if (color && color.length > 0) {
      setSelectedColor((prev) => prev || color[0]); // set only if not already selected
    }
    if (attributeDetail && attributeDetail.length > 0) {
      setSelectedAttribute((prev) => prev || attributeDetail[0]); // set only if not already selected
    }
    if (version && version.length > 0) {
      setSelectedversion((prev) => prev || version[0].version_id); // set only if not already selected
    }
  }, [color, attributeDetail, version]);

  const dateFormated = (rawDate) => {
    const dateObj = new Date(rawDate);

    // Option 1: Custom readable format
    const formatted = dateObj.toLocaleString("en-US", {
      year: "numeric",
      month: "long", // 'short' for "Jun", or '2-digit' for "06"
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true, // Ensures AM/PM
    });

    // Output: "June 8, 2025, 10:21 AM"
    return formatted;
  };
  // console.log("productReviews: ", productReviews);

  // console.log("Product Data : ", productData);
  console.log("productStock: ", productStock);

  return (
    <div id="wb-container" className="wb-effect10" style={{ maxWidth: "100%" }}>
      {network}
      <Navbar />
      {network ? (
        isMobile ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: "20px",
              gap: "20px",
            }}
          >
            <Skeleton width={300} height={500} />
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Skeleton width={70} height={70} />
              <Skeleton width={70} height={70} />
              <Skeleton width={70} height={70} />
            </div>
            <Skeleton width={350} height={20} />
            <Skeleton width={350} height={20} />
            <Skeleton width={350} height={20} />
            <Skeleton width={350} height={20} />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "start",
              justifyContent: "space-around",
              paddingTop: "20px",
            }}
          >
            <Skeleton width={400} height={500} />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "15px",
                maxHeight: "80vh",
                overflowY: "auto",
              }}
            >
              <Skeleton width={400} height={50} />
              <Skeleton width={400} height={250} />
              <Skeleton width={400} height={100} />
              <Skeleton width={400} height={100} />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <Skeleton width={400} height={150} />
              <Skeleton width={400} height={100} />
              <Skeleton width={400} height={100} />
              <Skeleton width={400} height={100} />
            </div>
          </div>
        )
      ) : (
        <div style={{ backgroundColor: "white" }}>
          <div className="ProductDetailsFinal">
            <div className="productDetailsImg">
              <div
                className="Product_Img_cart_buy"
                style={{ width: "100%", marginTop: "3px" }}
              >
                <ProductDetails imgs={productData} style={{ width: "100%" }} />

                {productDetails.map((item) =>
                  productStock.stock_status !== "OUT OF STOCK" ? (
                    <div className="Cart_buy_button" key={item.id}>
                      <div className="add_to_cart" onClick={handleAddToCart}>
                        <FontAwesomeIcon icon={faCartPlus} />
                        <span> {clicked ? "ADD TO CART" : "GO TO CART"}</span>
                      </div>
                      <div className="buy_now" onClick={handleBuyNow}>
                        <FontAwesomeIcon icon={faIndianRupeeSign} />
                        <span>BUY NOW</span>
                      </div>
                    </div>
                  ) : (
                    <div className="Cart_buy_button" key={item.id}>
                      <div className="add_to_cart disabled" disabled>
                        <FontAwesomeIcon icon={faCartPlus} />
                        <span> {clicked ? "ADD TO CART" : "GO TO CART"}</span>
                      </div>
                      <div className="buy_now disabled" disabled>
                        <FontAwesomeIcon icon={faIndianRupeeSign} />
                        <span>BUY NOW</span>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="ProductDetailsDIv">
              <h4 className="Product_name" style={{paddingLeft:"14px"}}>
                {productDetails.map((item, index) => (
                  <SafeComponent html={item.product_name} key={index} />
                ))}
              </h4>

              <div className="Ratings_div" onClick={handleReviewRatings}>
                <span style={{ fontWeight: "bold", fontSize: "18px" }}>
                  {productRatings}
                </span>
                <StarRating rating={productRatings} />

                {/* <FontAwesomeIcon icon={faStarHalfStroke} color='orange' /> */}
                {/* <span>..... 7000 Ratings</span> */}
              </div>
              {productDetails.map((item) => (
                <div
                  className="Product_Price_div"
                  style={{ display: "flex", gap: "4px", alignItems: "center" }}
                >
                  <p style={{ fontSize: "14px", marginBottom: "0px" }}>AED</p>
                  <p
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      marginBottom: "0px",
                    }}
                  >
                    {productStock.selling_price}
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      textDecoration: "line-through",
                      marginBottom: "0px",
                    }}
                  >
                    {productStock.mrp}
                  </p>
                  <p
                    style={{
                      fontSize: "16px",
                      color: "green",
                      marginBottom: "0px",
                    }}
                  >
                    {item.discout}% off
                  </p>
                </div>
              ))}
              {/* {productStock.stock === 0 ? ( */}
              <div
                style={{
                  paddingLeft: "15px",
                  color: "tomato",
                  fontWeight: "bold",
                  color:
                    productStock.stock_status === "IN STOCK"
                      ? "green"
                      : productStock.stock_status === "OUT OF STOCK"
                      ? "red"
                      : "#79a93b",
                }}
              >
                {productStock.stock_status}
              </div>
              {/* ): (<div style={{ paddingLeft: "15px", color: "green", fontWeight: "bold" }}>In Stock</div>)} */}

              <div className="vertical_slider">
                <Slider {...settings}>
                  {items.map((item, index) => (
                    <div
                      key={index}
                      className="p-1 bg-blue-500 text-warning text-dark-center text-lg rounded-lg font-italic "
                    >
                      {item}
                    </div>
                  ))}
                </Slider>
              </div>
              <div className="Express_delivery">
                <span className="Express">Premium</span>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{ color: "green" }}>Get it by Tomorrow</span>
                  <span style={{ color: "tomato" }}>(Order in 4h 24m)</span>
                </div>
              </div>
              <div className="product_details">
                {/* 6.5-inch LCD display with HD+ resolution (1600 x 720 pixels),
              MediaTek Dimensity 6020 octa-core processor, Dual camera setup
              with a 50MP main sensor */}
              </div>
              <div className="Different_color_product ">
                <div style={{ fontWeight: "600" }}>Choose Colour: </div>
                <div className="Images_div">
                  {color.map((item, index) => (
                    <div
                      key={index}
                      className="img_button_div"
                      onClick={() => {
                        setSelectedColor((prev) =>
                          prev === item ? null : item
                        );
                      }}
                      style={{
                        border: "2px solid",
                        borderColor: selectedColor === item ? "blue" : "#ccc",
                        cursor: "pointer",
                        width: "28px",
                        height: "28px",
                        borderRadius: "100%",
                        padding: "3px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // backgroundColor: `#${item}`,
                      }}
                    >
                      <span
                        style={{
                          width: "18px",
                          height: "18px",
                          borderRadius: "100%",
                          // padding: "2px",
                          backgroundColor: `#${item}`,
                        }}
                      ></span>
                      {/* <span style={{ width: "100%", textAlign: "center" }}>
                      {item}
                    </span> */}
                    </div>
                  ))}
                </div>
              </div>
              <div className="Different_color_product ">
                <div style={{ fontWeight: "600" }}>{attribute}</div>
                <div className="Images_div">
                  {attributeDetail.map((item, index) => (
                    <div
                      key={index}
                      className="img_button_div"
                      onClick={() => {
                        setSelectedAttribute((prev) =>
                          prev === item ? null : item
                        );
                        // Refresh();
                      }}
                      style={{
                        border: "2px solid",
                        borderColor:
                          selectedAttribute === item ? "blue" : "#ccc",
                        cursor: "pointer",
                        boxShadow:
                          "0 8px 16px 0 rgba(241, 235, 235, 0.2), 0 6px 20px 0 rgba(228, 226, 226, 0.19)",
                      }}
                    >
                      <span
                        style={{
                          width: "100%",
                          textAlign: "center",
                          display: "inline-block",
                        }}
                      >
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              {version.length !== 0 ? (
                <div className="Different_color_product ">
                  <div style={{ fontWeight: "600" }}>Version </div>
                  <div className="Images_div">
                    {version?.map((item) => (
                      <div
                        key={item.version_id}
                        className="img_button_div"
                        onClick={() => {
                          setSelectedversion((prev) =>
                            prev === item.version_id ? null : item.version_id
                          );
                          //  Refresh();
                        }}
                        style={{
                          border: "2px solid",
                          borderColor:
                            selectedversion === item.version_id
                              ? "blue"
                              : "#ccc",
                          cursor: "pointer",
                          width: "fit-content",
                          boxShadow:
                            "0 8px 16px 0 rgba(241, 235, 235, 0.2), 0 6px 20px 0 rgba(228, 226, 226, 0.19)",
                          padding: "2px 4px",
                        }}
                      >
                        <span
                          style={{
                            width: "100%",
                            textAlign: "center",
                            display: "flex",
                            fontSize: "14px",
                            justifyContent: "center",
                          }}
                        >
                          {item.version_name}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="product_details">
                {productDetails.map((item, index) => (
                  <SafeComponent html={item.short_description} key={index} />
                ))}
                {/* <span
                style={{
                  color: "blue",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                more...
              </span> */}
                <hr />
                <div className="delivery_features_div rounded shadow">
                  <div className="features_div">
                    <img
                      src="https://img.freepik.com/free-vector/delivery-service-illustrated_23-2148505081.jpg?semt=ais_hybrid&w=740"
                      alt="delivery"
                    />
                    <span style={{ textAlign: "center" }}>
                      Delivery by Eesouq
                    </span>
                  </div>
                  <div className="features_div">
                    <img
                      src="https://img.freepik.com/premium-vector/realistic-yellow-vector-star-3d_868719-848.jpg?semt=ais_hybrid&w=740"
                      alt="delivery"
                    />
                    <span style={{ textAlign: "center" }}>
                      High Rated Seller
                    </span>
                  </div>
                  <div className="features_div">
                    <img
                      src="https://www.shutterstock.com/image-vector/red-arrow-rotates-around-parcel-600nw-2319107375.jpg"
                      alt="delivery"
                    />
                    <span style={{ textAlign: "center" }}>Low Returns</span>
                  </div>
                  <div className="features_div">
                    <img
                      src="https://img.freepik.com/premium-photo/online-payment-concept-abstract-cartoon-style-credit-card-3d-rendering_476612-20916.jpg"
                      alt="delivery"
                    />
                    <span style={{ textAlign: "center" }}>
                      Cash on Delivery
                    </span>
                  </div>
                </div>

                <div
                  className="review_ratings_result"
                  ref={targetRef}
                  style={{ marginTop: "20px" }}
                >
                  <h2 style={{ fontWeight: "bold" }}>Ratings and Reviews: </h2>
                  <div
                    className=""
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="onlyNumber"
                      style={{
                        fontWeight: "semibold",
                        fontSize: "30px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span>{productRatings}</span>
                      <FontAwesomeIcon
                        icon={faStar}
                        color={productRatings === 0 ? "#ccc" : "orange"}
                      />
                    </div>
                    <div
                      className="colouring_limit"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        fontSize: "20px",
                        fontWeight: "semibold",
                      }}
                    >
                      <span>{review} Reviews</span>
                    </div>

                    <div onClick={() => setReviewOn(!reviewOn)}>
                      <p className="rate-product-btn">
                        {reviewOn ? "Cancel" : "Add Review"}
                      </p>
                    </div>
                  </div>

                  {reviewOn ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                      }}
                    >
                      <div style={{ display: "flex", gap: "10px" }}>
                        {Array.from({ length: 5 }).map((_, i) => (
                          <img
                            src={
                              starValue >= i + 1
                                ? "/assets/star-full.png"
                                : "/assets/star-empty.png"
                            }
                            className="rating-star"
                            onClick={() => setStarValue(i + 1)}
                          />
                        ))}
                      </div>
                      <textarea
                        value={reviewText}
                        onChange={(e) => setReviewText(e.target.value)}
                        placeholder="Write your reviews"
                      ></textarea>
                      <p
                        style={{
                          padding: "15px",
                          backgroundColor: "black",
                          color: "white",
                          width: "fit-content",
                          cursor: "pointer",
                        }}
                        onClick={HandleRateProduct}
                      >
                        {reviewSubmit ? "Submitting.." : "Submit"}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  <hr />

                  <div className="reviews-container">
                    {productReviews ? (
                      <div className="reviews-grid">
                        {productReviews?.map((items, i) => (
                          <div
                            key={i}
                            className="review-card"
                            style={{ animationDelay: `${i * 0.1}s` }}
                          >
                            <div className="reviewer-header">
                              <div className="avatar-container">
                                <img
                                  src={
                                    items.profile_pic || "/default-avatar.png"
                                  }
                                  alt={items.first_name}
                                  className="review-avatar"
                                  onError={(e) => {
                                    e.target.src = "/default-avatar.png";
                                  }}
                                />
                              </div>
                              <div className="reviewer-info">
                                <h4 className="reviewer-name">
                                  {items.first_name}
                                </h4>
                                <div className="rating-container">
                                  <span className="rating-number">
                                    {items.rating}.0
                                  </span>
                                  <StarRating rating={items.rating} />
                                </div>
                                <span className="review-date">
                                  {dateFormated(items.created_at)}
                                </span>
                              </div>
                            </div>
                            <div className="review-content">
                              <p>{items.description}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="no-reviews">
                        <p>No reviews yet</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="product-details-container">
             

              {/* <div className="bank-offers-section">
              <h3 className="section-title">BANK OFFERS</h3>
              <div className="offers-list">
                <div className="offer-item">
                  <div className="offer-icon">
                    <img
                      src="https://f.nooncdn.com/s/app/com/noon/icons/vip_credit_card.svg"
                      alt="VIP card"
                    />
                  </div>
                  <div className="offer-details">
                    <p>
                      <b>Earn AED 236.46</b> cashback with the Mashreq Eesouq
                      Credit Card.
                    </p>
                    <img
                      src="https://f.nooncdn.com/s/app/com/noon/design-system/simpleicons/chevron-right.svg"
                      alt="chevron right"
                      className="chevron-icon"
                    />
                  </div>
                </div>
                <div className="offer-item">
                  <div className="offer-icon">
                    <img
                      src="https://f.nooncdn.com/s/app/com/noon/icons/emi.svg"
                      alt="EMI"
                    />
                  </div>
                  <div className="offer-details">
                    <p>Monthly payment plans from AED 198</p>
                    <img
                      src="https://f.nooncdn.com/s/app/com/noon/design-system/simpleicons/chevron-right.svg"
                      alt="chevron right"
                      className="chevron-icon"
                    />
                  </div>
                </div>
              </div>
            </div> */}

              {/* <div className="seller-section">
              <h3 className="section-title">SELLER</h3>
              <div className="seller-info">
                <div
                  className="seller-logo"
                  style={{
                    backgroundImage:
                      "url(https://p.nooncdn.com/reviews-partners/partner_assets/297336/logo_ae_1740309834.025676.png)",
                  }}
                ></div>
                <div className="seller-details">
                  <div className="seller-name">
                    <span>Sold by</span>
                    <span className="seller-company">TECH-TRUST</span>
                  </div>
                  <div className="seller-ratings">
                    <div className="rating-pill">
                      <span>4.3</span>
                      <img
                        src="https://f.nooncdn.com/s/app/com/noon/design-system/simpleicons/star-filled-v2.svg"
                        alt="star"
                      />
                    </div>
                    <div className="positive-ratings">
                      <span>84% Positive Ratings</span>
                    </div>
                  </div>
                </div>
                <img
                  src="https://f.nooncdn.com/s/app/com/noon/design-system/simpleicons/chevron-right.svg"
                  alt="chevron right"
                  className="chevron-icon"
                />
              </div>

              <div className="seller-metrics">
                <div className="metric-item">
                  <img
                    src="https://t4.ftcdn.net/jpg/00/10/75/61/360_F_10756146_ZFuCF60wkNFUU9zZ2u27665QeawHuMEK.jpg"
                    alt="Item as Described"
                    height="30px"
                    width="30px"
                  />

                  <div className="metric-details">
                    <p>Item as Described</p>
                    <div className="rating-bar">
                      <div className="bar-fill" style={{ width: "90%" }}></div>
                      <span className="percentage">90%</span>
                    </div>
                  </div>
                </div>
                <div className="metric-item inline">
                  <img
                    src="https://www.shutterstock.com/image-vector/red-arrow-rotates-around-parcel-600nw-2319107375.jpg"
                    alt="Low Return Seller"
                    height="30px"
                    width="30px"
                  />
                  <p>Low Return Seller</p>
                </div>
                <div className="metric-item inline">
                  <img
                    src="https://img.freepik.com/free-vector/like-button-thumbs-up-cartoon-style_78370-1159.jpg"
                    alt="Great Recent Rating"
                    height="30px"
                    width="30px"
                  />
                  <p>Great Recent Rating</p>
                </div>
              </div>
            </div> */}

              <div className="support-details">
                <div className="support-item" style={{display:"flex",alignItems:"start"}}>
                  {/* <img
                  src="https://img.freepik.com/premium-vector/warranty-icon-design-warranty-badge-approval-icon-sign-red-color-button-design_565585-12735.jpg"
                  alt="warranty"
                  height="30px"
                  width="30px"
                /> */}
                  <FontAwesomeIcon icon={faShieldAlt} size="lg" color="hsl(90, 35%, 46%)" style={{paddingTop:"3px",paddingRight:"2.5px"}}/>
                  <span>Enjoy a 1-Year Warranty</span>
                 
                </div>
                <div className="support-item" style={{display:"flex",alignItems:"start"}}>
                  {/* <img
                  src="https://png.pngtree.com/png-clipart/20231029/original/pngtree-free-shipping-green-button-round-picture-image_13213917.png"
                  alt="Noon Locker"
                  height="30px"
                  width="30px"
                /> */}
                  <FontAwesomeIcon icon={faTruck}  color="hsl(90, 35%, 46%)" style={{paddingTop:"4px",fontSize:"16px"}}/>
                  <span>Free delivery on Lockers & Pickup Points</span>
                  {/* <img
                    src="https://f.nooncdn.com/s/app/com/noon/design-system/simpleicons/chevron-right.svg"
                    alt="chevron right"
                    className="chevron-icon"
                  /> */}
                </div>
                <div className="support-item" style={{display:"flex",alignItems:"flex-start"}}>
                  {/* <img
                  src="https://png.pngtree.com/png-clipart/20220226/ourmid/pngtree-blue-round-crystal-button-return-icon-png-image_4405424.png"
                  alt="Returns"
                  height="30px"
                  width="30px"
                /> */}
                  <FontAwesomeIcon
                    icon={faRightLeft}
                   
                    color="hsl(90, 35%, 46%)"
                    style={{paddingTop:"4px",paddingRight:"3px",fontSize:"17px"}}
                  />
                  <span>Hassle-Free Returns at No Extra Cost</span>
                  {/* <img
                    src="https://f.nooncdn.com/s/app/com/noon/design-system/simpleicons/chevron-right.svg"
                    alt="chevron right"
                    className="chevron-icon"
                  /> */}
                </div>
              </div>

              <div className="other-offers">
                <button className="other-offers-button">
                  <div className="offer-content" style={{display:"flex",alignItems:"start"}}>
                    {/* <img
                    src="https://thumbs.dreamstime.com/z/special-offer-button-37878324.jpg"
                    alt="other offers"
                    height="30px"
                    width="30px"
                  /> */}
                    <FontAwesomeIcon
                      icon={faBriefcase}
                      
                      color="hsl(90, 35%, 46%)"
                      style={{paddingTop:"3.5px",fontSize:"18px"}}
                    />
                    <p>Check Out Offers from 7 Additional Sellers</p>
                  </div>
                
                </button>
              </div>

            
            </div>
          </div>
          {slug ? (
            <SimilarProducts
              url={`/user_api/product/trending-list-by-category?slug=${slug}&&access_token=${JSON.parse(
                accessToken
              )}`}
            />
          ) : (
            ""
          )}
        </div>
      )}
      {/* <ScrollToTopButton /> */}
      <Footer />
    </div>
  );
}

export default ProductDetailsFinal;
